"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgChangeOrgOwnerResponse = exports.MsgChangeOrgOwner = exports.MsgSetMintauthResponse = exports.MsgSetMintauth = exports.MsgSetFeeConfigResponse = exports.MsgSetFeeConfig = exports.MsgResyncAttributes = exports.MsgShowAttributesResponse = exports.MsgShowAttributes = exports.MsgResyncAttributesResponse = exports.MsgRemoveSystemActionerResponse = exports.MsgRemoveSystemActioner = exports.MsgAddSystemActionerResponse = exports.MsgAddSystemActioner = exports.MsgChangeSchemaOwnerResponse = exports.MsgChangeSchemaOwner = exports.MsgToggleActionResponse = exports.MsgToggleAction = exports.MsgSetBaseUriResponse = exports.MsgSetBaseUri = exports.MsgSetNFTAttributeResponse = exports.MsgSetNFTAttribute = exports.MsgAddActionResponse = exports.MsgAddAction = exports.MsgAddAttributeResponse = exports.MsgAddAttribute = exports.MsgPerformActionByAdminResponse = exports.MsgPerformActionByAdmin = exports.ActionParameter = exports.UpdatedOriginData = exports.UpdatedOpenseaAttributes = exports.OpenseaAttribute = exports.MsgCreateMetadataResponse = exports.MsgCreateMetadata = exports.MsgCreateNFTSchemaResponse = exports.MsgCreateNFTSchema = exports.feeSubjectToJSON = exports.feeSubjectFromJSON = exports.FeeSubject = exports.authorizeToToJSON = exports.authorizeToFromJSON = exports.AuthorizeTo = exports.attributeLocationToJSON = exports.attributeLocationFromJSON = exports.AttributeLocation = exports.protobufPackage = void 0;
/* eslint-disable */
var minimal_1 = require("protobufjs/minimal");
var any_1 = require("../google/protobuf/any");
var on_chain_data_1 = require("../nftmngr/on_chain_data");
exports.protobufPackage = "thesixnetwork.sixnft.nftmngr";
var AttributeLocation;
(function (AttributeLocation) {
    AttributeLocation[AttributeLocation["NFT_ATTRIBUTE"] = 0] = "NFT_ATTRIBUTE";
    AttributeLocation[AttributeLocation["TOKEN_ATTRIBUTE"] = 1] = "TOKEN_ATTRIBUTE";
    AttributeLocation[AttributeLocation["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AttributeLocation = exports.AttributeLocation || (exports.AttributeLocation = {}));
function attributeLocationFromJSON(object) {
    switch (object) {
        case 0:
        case "NFT_ATTRIBUTE":
            return AttributeLocation.NFT_ATTRIBUTE;
        case 1:
        case "TOKEN_ATTRIBUTE":
            return AttributeLocation.TOKEN_ATTRIBUTE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AttributeLocation.UNRECOGNIZED;
    }
}
exports.attributeLocationFromJSON = attributeLocationFromJSON;
function attributeLocationToJSON(object) {
    switch (object) {
        case AttributeLocation.NFT_ATTRIBUTE:
            return "NFT_ATTRIBUTE";
        case AttributeLocation.TOKEN_ATTRIBUTE:
            return "TOKEN_ATTRIBUTE";
        default:
            return "UNKNOWN";
    }
}
exports.attributeLocationToJSON = attributeLocationToJSON;
var AuthorizeTo;
(function (AuthorizeTo) {
    AuthorizeTo[AuthorizeTo["SYSTEM"] = 0] = "SYSTEM";
    AuthorizeTo[AuthorizeTo["ALL"] = 1] = "ALL";
    AuthorizeTo[AuthorizeTo["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AuthorizeTo = exports.AuthorizeTo || (exports.AuthorizeTo = {}));
function authorizeToFromJSON(object) {
    switch (object) {
        case 0:
        case "SYSTEM":
            return AuthorizeTo.SYSTEM;
        case 1:
        case "ALL":
            return AuthorizeTo.ALL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AuthorizeTo.UNRECOGNIZED;
    }
}
exports.authorizeToFromJSON = authorizeToFromJSON;
function authorizeToToJSON(object) {
    switch (object) {
        case AuthorizeTo.SYSTEM:
            return "SYSTEM";
        case AuthorizeTo.ALL:
            return "ALL";
        default:
            return "UNKNOWN";
    }
}
exports.authorizeToToJSON = authorizeToToJSON;
var FeeSubject;
(function (FeeSubject) {
    FeeSubject[FeeSubject["CREATE_NFT_SCHEMA"] = 0] = "CREATE_NFT_SCHEMA";
    FeeSubject[FeeSubject["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(FeeSubject = exports.FeeSubject || (exports.FeeSubject = {}));
function feeSubjectFromJSON(object) {
    switch (object) {
        case 0:
        case "CREATE_NFT_SCHEMA":
            return FeeSubject.CREATE_NFT_SCHEMA;
        case -1:
        case "UNRECOGNIZED":
        default:
            return FeeSubject.UNRECOGNIZED;
    }
}
exports.feeSubjectFromJSON = feeSubjectFromJSON;
function feeSubjectToJSON(object) {
    switch (object) {
        case FeeSubject.CREATE_NFT_SCHEMA:
            return "CREATE_NFT_SCHEMA";
        default:
            return "UNKNOWN";
    }
}
exports.feeSubjectToJSON = feeSubjectToJSON;
var baseMsgCreateNFTSchema = { creator: "", nftSchemaBase64: "" };
exports.MsgCreateNFTSchema = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.nftSchemaBase64 !== "") {
            writer.uint32(18).string(message.nftSchemaBase64);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgCreateNFTSchema);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.nftSchemaBase64 = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgCreateNFTSchema);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaBase64 !== undefined &&
            object.nftSchemaBase64 !== null) {
            message.nftSchemaBase64 = String(object.nftSchemaBase64);
        }
        else {
            message.nftSchemaBase64 = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.nftSchemaBase64 !== undefined &&
            (obj.nftSchemaBase64 = message.nftSchemaBase64);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgCreateNFTSchema);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaBase64 !== undefined &&
            object.nftSchemaBase64 !== null) {
            message.nftSchemaBase64 = object.nftSchemaBase64;
        }
        else {
            message.nftSchemaBase64 = "";
        }
        return message;
    },
};
var baseMsgCreateNFTSchemaResponse = { code: "" };
exports.MsgCreateNFTSchemaResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.code !== "") {
            writer.uint32(10).string(message.code);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgCreateNFTSchemaResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.code = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgCreateNFTSchemaResponse);
        if (object.code !== undefined && object.code !== null) {
            message.code = String(object.code);
        }
        else {
            message.code = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.code !== undefined && (obj.code = message.code);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgCreateNFTSchemaResponse);
        if (object.code !== undefined && object.code !== null) {
            message.code = object.code;
        }
        else {
            message.code = "";
        }
        return message;
    },
};
var baseMsgCreateMetadata = {
    creator: "",
    nftSchemaCode: "",
    tokenId: "",
    base64NFTData: "",
};
exports.MsgCreateMetadata = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.nftSchemaCode !== "") {
            writer.uint32(18).string(message.nftSchemaCode);
        }
        if (message.tokenId !== "") {
            writer.uint32(26).string(message.tokenId);
        }
        if (message.base64NFTData !== "") {
            writer.uint32(34).string(message.base64NFTData);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgCreateMetadata);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.nftSchemaCode = reader.string();
                    break;
                case 3:
                    message.tokenId = reader.string();
                    break;
                case 4:
                    message.base64NFTData = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgCreateMetadata);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.tokenId !== undefined && object.tokenId !== null) {
            message.tokenId = String(object.tokenId);
        }
        else {
            message.tokenId = "";
        }
        if (object.base64NFTData !== undefined && object.base64NFTData !== null) {
            message.base64NFTData = String(object.base64NFTData);
        }
        else {
            message.base64NFTData = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.tokenId !== undefined && (obj.tokenId = message.tokenId);
        message.base64NFTData !== undefined &&
            (obj.base64NFTData = message.base64NFTData);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgCreateMetadata);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.tokenId !== undefined && object.tokenId !== null) {
            message.tokenId = object.tokenId;
        }
        else {
            message.tokenId = "";
        }
        if (object.base64NFTData !== undefined && object.base64NFTData !== null) {
            message.base64NFTData = object.base64NFTData;
        }
        else {
            message.base64NFTData = "";
        }
        return message;
    },
};
var baseMsgCreateMetadataResponse = {
    nftSchemaCode: "",
    tokenId: "",
};
exports.MsgCreateMetadataResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.nftSchemaCode !== "") {
            writer.uint32(10).string(message.nftSchemaCode);
        }
        if (message.tokenId !== "") {
            writer.uint32(18).string(message.tokenId);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgCreateMetadataResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nftSchemaCode = reader.string();
                    break;
                case 2:
                    message.tokenId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgCreateMetadataResponse);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.tokenId !== undefined && object.tokenId !== null) {
            message.tokenId = String(object.tokenId);
        }
        else {
            message.tokenId = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.tokenId !== undefined && (obj.tokenId = message.tokenId);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgCreateMetadataResponse);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.tokenId !== undefined && object.tokenId !== null) {
            message.tokenId = object.tokenId;
        }
        else {
            message.tokenId = "";
        }
        return message;
    },
};
var baseOpenseaAttribute = { trait_type: "" };
exports.OpenseaAttribute = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.trait_type !== "") {
            writer.uint32(10).string(message.trait_type);
        }
        if (message.value !== undefined) {
            any_1.Any.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseOpenseaAttribute);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.trait_type = reader.string();
                    break;
                case 2:
                    message.value = any_1.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseOpenseaAttribute);
        if (object.trait_type !== undefined && object.trait_type !== null) {
            message.trait_type = String(object.trait_type);
        }
        else {
            message.trait_type = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = any_1.Any.fromJSON(object.value);
        }
        else {
            message.value = undefined;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.trait_type !== undefined && (obj.trait_type = message.trait_type);
        message.value !== undefined &&
            (obj.value = message.value ? any_1.Any.toJSON(message.value) : undefined);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseOpenseaAttribute);
        if (object.trait_type !== undefined && object.trait_type !== null) {
            message.trait_type = object.trait_type;
        }
        else {
            message.trait_type = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = any_1.Any.fromPartial(object.value);
        }
        else {
            message.value = undefined;
        }
        return message;
    },
};
var baseUpdatedOpenseaAttributes = {};
exports.UpdatedOpenseaAttributes = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        for (var _i = 0, _a = message.attributes; _i < _a.length; _i++) {
            var v = _a[_i];
            exports.OpenseaAttribute.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseUpdatedOpenseaAttributes);
        message.attributes = [];
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.attributes.push(exports.OpenseaAttribute.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseUpdatedOpenseaAttributes);
        message.attributes = [];
        if (object.attributes !== undefined && object.attributes !== null) {
            for (var _i = 0, _a = object.attributes; _i < _a.length; _i++) {
                var e = _a[_i];
                message.attributes.push(exports.OpenseaAttribute.fromJSON(e));
            }
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        if (message.attributes) {
            obj.attributes = message.attributes.map(function (e) {
                return e ? exports.OpenseaAttribute.toJSON(e) : undefined;
            });
        }
        else {
            obj.attributes = [];
        }
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseUpdatedOpenseaAttributes);
        message.attributes = [];
        if (object.attributes !== undefined && object.attributes !== null) {
            for (var _i = 0, _a = object.attributes; _i < _a.length; _i++) {
                var e = _a[_i];
                message.attributes.push(exports.OpenseaAttribute.fromPartial(e));
            }
        }
        return message;
    },
};
var baseUpdatedOriginData = {};
exports.UpdatedOriginData = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.opensea !== undefined) {
            exports.UpdatedOpenseaAttributes.encode(message.opensea, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseUpdatedOriginData);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.opensea = exports.UpdatedOpenseaAttributes.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseUpdatedOriginData);
        if (object.opensea !== undefined && object.opensea !== null) {
            message.opensea = exports.UpdatedOpenseaAttributes.fromJSON(object.opensea);
        }
        else {
            message.opensea = undefined;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.opensea !== undefined &&
            (obj.opensea = message.opensea
                ? exports.UpdatedOpenseaAttributes.toJSON(message.opensea)
                : undefined);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseUpdatedOriginData);
        if (object.opensea !== undefined && object.opensea !== null) {
            message.opensea = exports.UpdatedOpenseaAttributes.fromPartial(object.opensea);
        }
        else {
            message.opensea = undefined;
        }
        return message;
    },
};
var baseActionParameter = { name: "", value: "" };
exports.ActionParameter = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseActionParameter);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseActionParameter);
        if (object.name !== undefined && object.name !== null) {
            message.name = String(object.name);
        }
        else {
            message.name = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = String(object.value);
        }
        else {
            message.value = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseActionParameter);
        if (object.name !== undefined && object.name !== null) {
            message.name = object.name;
        }
        else {
            message.name = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        else {
            message.value = "";
        }
        return message;
    },
};
var baseMsgPerformActionByAdmin = {
    creator: "",
    nft_schema_code: "",
    tokenId: "",
    action: "",
    ref_id: "",
};
exports.MsgPerformActionByAdmin = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.nft_schema_code !== "") {
            writer.uint32(18).string(message.nft_schema_code);
        }
        if (message.tokenId !== "") {
            writer.uint32(26).string(message.tokenId);
        }
        if (message.action !== "") {
            writer.uint32(34).string(message.action);
        }
        if (message.ref_id !== "") {
            writer.uint32(42).string(message.ref_id);
        }
        for (var _i = 0, _a = message.parameters; _i < _a.length; _i++) {
            var v = _a[_i];
            exports.ActionParameter.encode(v, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgPerformActionByAdmin);
        message.parameters = [];
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.nft_schema_code = reader.string();
                    break;
                case 3:
                    message.tokenId = reader.string();
                    break;
                case 4:
                    message.action = reader.string();
                    break;
                case 5:
                    message.ref_id = reader.string();
                    break;
                case 6:
                    message.parameters.push(exports.ActionParameter.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgPerformActionByAdmin);
        message.parameters = [];
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.nft_schema_code !== undefined &&
            object.nft_schema_code !== null) {
            message.nft_schema_code = String(object.nft_schema_code);
        }
        else {
            message.nft_schema_code = "";
        }
        if (object.tokenId !== undefined && object.tokenId !== null) {
            message.tokenId = String(object.tokenId);
        }
        else {
            message.tokenId = "";
        }
        if (object.action !== undefined && object.action !== null) {
            message.action = String(object.action);
        }
        else {
            message.action = "";
        }
        if (object.ref_id !== undefined && object.ref_id !== null) {
            message.ref_id = String(object.ref_id);
        }
        else {
            message.ref_id = "";
        }
        if (object.parameters !== undefined && object.parameters !== null) {
            for (var _i = 0, _a = object.parameters; _i < _a.length; _i++) {
                var e = _a[_i];
                message.parameters.push(exports.ActionParameter.fromJSON(e));
            }
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.nft_schema_code !== undefined &&
            (obj.nft_schema_code = message.nft_schema_code);
        message.tokenId !== undefined && (obj.tokenId = message.tokenId);
        message.action !== undefined && (obj.action = message.action);
        message.ref_id !== undefined && (obj.ref_id = message.ref_id);
        if (message.parameters) {
            obj.parameters = message.parameters.map(function (e) {
                return e ? exports.ActionParameter.toJSON(e) : undefined;
            });
        }
        else {
            obj.parameters = [];
        }
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgPerformActionByAdmin);
        message.parameters = [];
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.nft_schema_code !== undefined &&
            object.nft_schema_code !== null) {
            message.nft_schema_code = object.nft_schema_code;
        }
        else {
            message.nft_schema_code = "";
        }
        if (object.tokenId !== undefined && object.tokenId !== null) {
            message.tokenId = object.tokenId;
        }
        else {
            message.tokenId = "";
        }
        if (object.action !== undefined && object.action !== null) {
            message.action = object.action;
        }
        else {
            message.action = "";
        }
        if (object.ref_id !== undefined && object.ref_id !== null) {
            message.ref_id = object.ref_id;
        }
        else {
            message.ref_id = "";
        }
        if (object.parameters !== undefined && object.parameters !== null) {
            for (var _i = 0, _a = object.parameters; _i < _a.length; _i++) {
                var e = _a[_i];
                message.parameters.push(exports.ActionParameter.fromPartial(e));
            }
        }
        return message;
    },
};
var baseMsgPerformActionByAdminResponse = {
    nft_schema_code: "",
    token_id: "",
};
exports.MsgPerformActionByAdminResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.nft_schema_code !== "") {
            writer.uint32(10).string(message.nft_schema_code);
        }
        if (message.token_id !== "") {
            writer.uint32(18).string(message.token_id);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgPerformActionByAdminResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nft_schema_code = reader.string();
                    break;
                case 2:
                    message.token_id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgPerformActionByAdminResponse);
        if (object.nft_schema_code !== undefined &&
            object.nft_schema_code !== null) {
            message.nft_schema_code = String(object.nft_schema_code);
        }
        else {
            message.nft_schema_code = "";
        }
        if (object.token_id !== undefined && object.token_id !== null) {
            message.token_id = String(object.token_id);
        }
        else {
            message.token_id = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.nft_schema_code !== undefined &&
            (obj.nft_schema_code = message.nft_schema_code);
        message.token_id !== undefined && (obj.token_id = message.token_id);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgPerformActionByAdminResponse);
        if (object.nft_schema_code !== undefined &&
            object.nft_schema_code !== null) {
            message.nft_schema_code = object.nft_schema_code;
        }
        else {
            message.nft_schema_code = "";
        }
        if (object.token_id !== undefined && object.token_id !== null) {
            message.token_id = object.token_id;
        }
        else {
            message.token_id = "";
        }
        return message;
    },
};
var baseMsgAddAttribute = {
    creator: "",
    code: "",
    location: 0,
    base64NewAttriuteDefenition: "",
};
exports.MsgAddAttribute = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.code !== "") {
            writer.uint32(18).string(message.code);
        }
        if (message.location !== 0) {
            writer.uint32(24).int32(message.location);
        }
        if (message.base64NewAttriuteDefenition !== "") {
            writer.uint32(34).string(message.base64NewAttriuteDefenition);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgAddAttribute);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.code = reader.string();
                    break;
                case 3:
                    message.location = reader.int32();
                    break;
                case 4:
                    message.base64NewAttriuteDefenition = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgAddAttribute);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.code !== undefined && object.code !== null) {
            message.code = String(object.code);
        }
        else {
            message.code = "";
        }
        if (object.location !== undefined && object.location !== null) {
            message.location = attributeLocationFromJSON(object.location);
        }
        else {
            message.location = 0;
        }
        if (object.base64NewAttriuteDefenition !== undefined &&
            object.base64NewAttriuteDefenition !== null) {
            message.base64NewAttriuteDefenition = String(object.base64NewAttriuteDefenition);
        }
        else {
            message.base64NewAttriuteDefenition = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.code !== undefined && (obj.code = message.code);
        message.location !== undefined &&
            (obj.location = attributeLocationToJSON(message.location));
        message.base64NewAttriuteDefenition !== undefined &&
            (obj.base64NewAttriuteDefenition = message.base64NewAttriuteDefenition);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgAddAttribute);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.code !== undefined && object.code !== null) {
            message.code = object.code;
        }
        else {
            message.code = "";
        }
        if (object.location !== undefined && object.location !== null) {
            message.location = object.location;
        }
        else {
            message.location = 0;
        }
        if (object.base64NewAttriuteDefenition !== undefined &&
            object.base64NewAttriuteDefenition !== null) {
            message.base64NewAttriuteDefenition = object.base64NewAttriuteDefenition;
        }
        else {
            message.base64NewAttriuteDefenition = "";
        }
        return message;
    },
};
var baseMsgAddAttributeResponse = { code: "", name: "" };
exports.MsgAddAttributeResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.code !== "") {
            writer.uint32(10).string(message.code);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        if (message.onchainData !== undefined) {
            on_chain_data_1.OnChainData.encode(message.onchainData, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgAddAttributeResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.code = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.onchainData = on_chain_data_1.OnChainData.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgAddAttributeResponse);
        if (object.code !== undefined && object.code !== null) {
            message.code = String(object.code);
        }
        else {
            message.code = "";
        }
        if (object.name !== undefined && object.name !== null) {
            message.name = String(object.name);
        }
        else {
            message.name = "";
        }
        if (object.onchainData !== undefined && object.onchainData !== null) {
            message.onchainData = on_chain_data_1.OnChainData.fromJSON(object.onchainData);
        }
        else {
            message.onchainData = undefined;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.code !== undefined && (obj.code = message.code);
        message.name !== undefined && (obj.name = message.name);
        message.onchainData !== undefined &&
            (obj.onchainData = message.onchainData
                ? on_chain_data_1.OnChainData.toJSON(message.onchainData)
                : undefined);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgAddAttributeResponse);
        if (object.code !== undefined && object.code !== null) {
            message.code = object.code;
        }
        else {
            message.code = "";
        }
        if (object.name !== undefined && object.name !== null) {
            message.name = object.name;
        }
        else {
            message.name = "";
        }
        if (object.onchainData !== undefined && object.onchainData !== null) {
            message.onchainData = on_chain_data_1.OnChainData.fromPartial(object.onchainData);
        }
        else {
            message.onchainData = undefined;
        }
        return message;
    },
};
var baseMsgAddAction = { creator: "", code: "", base64NewAction: "" };
exports.MsgAddAction = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.code !== "") {
            writer.uint32(18).string(message.code);
        }
        if (message.base64NewAction !== "") {
            writer.uint32(26).string(message.base64NewAction);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgAddAction);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.code = reader.string();
                    break;
                case 3:
                    message.base64NewAction = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgAddAction);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.code !== undefined && object.code !== null) {
            message.code = String(object.code);
        }
        else {
            message.code = "";
        }
        if (object.base64NewAction !== undefined &&
            object.base64NewAction !== null) {
            message.base64NewAction = String(object.base64NewAction);
        }
        else {
            message.base64NewAction = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.code !== undefined && (obj.code = message.code);
        message.base64NewAction !== undefined &&
            (obj.base64NewAction = message.base64NewAction);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgAddAction);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.code !== undefined && object.code !== null) {
            message.code = object.code;
        }
        else {
            message.code = "";
        }
        if (object.base64NewAction !== undefined &&
            object.base64NewAction !== null) {
            message.base64NewAction = object.base64NewAction;
        }
        else {
            message.base64NewAction = "";
        }
        return message;
    },
};
var baseMsgAddActionResponse = { code: "", name: "" };
exports.MsgAddActionResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.code !== "") {
            writer.uint32(10).string(message.code);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        if (message.onchainData !== undefined) {
            on_chain_data_1.OnChainData.encode(message.onchainData, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgAddActionResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.code = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.onchainData = on_chain_data_1.OnChainData.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgAddActionResponse);
        if (object.code !== undefined && object.code !== null) {
            message.code = String(object.code);
        }
        else {
            message.code = "";
        }
        if (object.name !== undefined && object.name !== null) {
            message.name = String(object.name);
        }
        else {
            message.name = "";
        }
        if (object.onchainData !== undefined && object.onchainData !== null) {
            message.onchainData = on_chain_data_1.OnChainData.fromJSON(object.onchainData);
        }
        else {
            message.onchainData = undefined;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.code !== undefined && (obj.code = message.code);
        message.name !== undefined && (obj.name = message.name);
        message.onchainData !== undefined &&
            (obj.onchainData = message.onchainData
                ? on_chain_data_1.OnChainData.toJSON(message.onchainData)
                : undefined);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgAddActionResponse);
        if (object.code !== undefined && object.code !== null) {
            message.code = object.code;
        }
        else {
            message.code = "";
        }
        if (object.name !== undefined && object.name !== null) {
            message.name = object.name;
        }
        else {
            message.name = "";
        }
        if (object.onchainData !== undefined && object.onchainData !== null) {
            message.onchainData = on_chain_data_1.OnChainData.fromPartial(object.onchainData);
        }
        else {
            message.onchainData = undefined;
        }
        return message;
    },
};
var baseMsgSetNFTAttribute = {
    creator: "",
    nft_schema_code: "",
    base64_nft_attribute_value: "",
};
exports.MsgSetNFTAttribute = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.nft_schema_code !== "") {
            writer.uint32(18).string(message.nft_schema_code);
        }
        if (message.base64_nft_attribute_value !== "") {
            writer.uint32(26).string(message.base64_nft_attribute_value);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgSetNFTAttribute);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.nft_schema_code = reader.string();
                    break;
                case 3:
                    message.base64_nft_attribute_value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgSetNFTAttribute);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.nft_schema_code !== undefined &&
            object.nft_schema_code !== null) {
            message.nft_schema_code = String(object.nft_schema_code);
        }
        else {
            message.nft_schema_code = "";
        }
        if (object.base64_nft_attribute_value !== undefined &&
            object.base64_nft_attribute_value !== null) {
            message.base64_nft_attribute_value = String(object.base64_nft_attribute_value);
        }
        else {
            message.base64_nft_attribute_value = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.nft_schema_code !== undefined &&
            (obj.nft_schema_code = message.nft_schema_code);
        message.base64_nft_attribute_value !== undefined &&
            (obj.base64_nft_attribute_value = message.base64_nft_attribute_value);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgSetNFTAttribute);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.nft_schema_code !== undefined &&
            object.nft_schema_code !== null) {
            message.nft_schema_code = object.nft_schema_code;
        }
        else {
            message.nft_schema_code = "";
        }
        if (object.base64_nft_attribute_value !== undefined &&
            object.base64_nft_attribute_value !== null) {
            message.base64_nft_attribute_value = object.base64_nft_attribute_value;
        }
        else {
            message.base64_nft_attribute_value = "";
        }
        return message;
    },
};
var baseMsgSetNFTAttributeResponse = {
    nft_schema_code: "",
    attribute_name: "",
    nft_attribute_value: "",
};
exports.MsgSetNFTAttributeResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.nft_schema_code !== "") {
            writer.uint32(10).string(message.nft_schema_code);
        }
        if (message.attribute_name !== "") {
            writer.uint32(18).string(message.attribute_name);
        }
        if (message.nft_attribute_value !== "") {
            writer.uint32(26).string(message.nft_attribute_value);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgSetNFTAttributeResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nft_schema_code = reader.string();
                    break;
                case 2:
                    message.attribute_name = reader.string();
                    break;
                case 3:
                    message.nft_attribute_value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgSetNFTAttributeResponse);
        if (object.nft_schema_code !== undefined &&
            object.nft_schema_code !== null) {
            message.nft_schema_code = String(object.nft_schema_code);
        }
        else {
            message.nft_schema_code = "";
        }
        if (object.attribute_name !== undefined && object.attribute_name !== null) {
            message.attribute_name = String(object.attribute_name);
        }
        else {
            message.attribute_name = "";
        }
        if (object.nft_attribute_value !== undefined &&
            object.nft_attribute_value !== null) {
            message.nft_attribute_value = String(object.nft_attribute_value);
        }
        else {
            message.nft_attribute_value = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.nft_schema_code !== undefined &&
            (obj.nft_schema_code = message.nft_schema_code);
        message.attribute_name !== undefined &&
            (obj.attribute_name = message.attribute_name);
        message.nft_attribute_value !== undefined &&
            (obj.nft_attribute_value = message.nft_attribute_value);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgSetNFTAttributeResponse);
        if (object.nft_schema_code !== undefined &&
            object.nft_schema_code !== null) {
            message.nft_schema_code = object.nft_schema_code;
        }
        else {
            message.nft_schema_code = "";
        }
        if (object.attribute_name !== undefined && object.attribute_name !== null) {
            message.attribute_name = object.attribute_name;
        }
        else {
            message.attribute_name = "";
        }
        if (object.nft_attribute_value !== undefined &&
            object.nft_attribute_value !== null) {
            message.nft_attribute_value = object.nft_attribute_value;
        }
        else {
            message.nft_attribute_value = "";
        }
        return message;
    },
};
var baseMsgSetBaseUri = { creator: "", code: "", newBaseUri: "" };
exports.MsgSetBaseUri = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.code !== "") {
            writer.uint32(18).string(message.code);
        }
        if (message.newBaseUri !== "") {
            writer.uint32(26).string(message.newBaseUri);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgSetBaseUri);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.code = reader.string();
                    break;
                case 3:
                    message.newBaseUri = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgSetBaseUri);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.code !== undefined && object.code !== null) {
            message.code = String(object.code);
        }
        else {
            message.code = "";
        }
        if (object.newBaseUri !== undefined && object.newBaseUri !== null) {
            message.newBaseUri = String(object.newBaseUri);
        }
        else {
            message.newBaseUri = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.code !== undefined && (obj.code = message.code);
        message.newBaseUri !== undefined && (obj.newBaseUri = message.newBaseUri);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgSetBaseUri);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.code !== undefined && object.code !== null) {
            message.code = object.code;
        }
        else {
            message.code = "";
        }
        if (object.newBaseUri !== undefined && object.newBaseUri !== null) {
            message.newBaseUri = object.newBaseUri;
        }
        else {
            message.newBaseUri = "";
        }
        return message;
    },
};
var baseMsgSetBaseUriResponse = { code: "", uri: "" };
exports.MsgSetBaseUriResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.code !== "") {
            writer.uint32(10).string(message.code);
        }
        if (message.uri !== "") {
            writer.uint32(18).string(message.uri);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgSetBaseUriResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.code = reader.string();
                    break;
                case 2:
                    message.uri = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgSetBaseUriResponse);
        if (object.code !== undefined && object.code !== null) {
            message.code = String(object.code);
        }
        else {
            message.code = "";
        }
        if (object.uri !== undefined && object.uri !== null) {
            message.uri = String(object.uri);
        }
        else {
            message.uri = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.code !== undefined && (obj.code = message.code);
        message.uri !== undefined && (obj.uri = message.uri);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgSetBaseUriResponse);
        if (object.code !== undefined && object.code !== null) {
            message.code = object.code;
        }
        else {
            message.code = "";
        }
        if (object.uri !== undefined && object.uri !== null) {
            message.uri = object.uri;
        }
        else {
            message.uri = "";
        }
        return message;
    },
};
var baseMsgToggleAction = {
    creator: "",
    code: "",
    action: "",
    disable: false,
};
exports.MsgToggleAction = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.code !== "") {
            writer.uint32(18).string(message.code);
        }
        if (message.action !== "") {
            writer.uint32(26).string(message.action);
        }
        if (message.disable === true) {
            writer.uint32(32).bool(message.disable);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgToggleAction);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.code = reader.string();
                    break;
                case 3:
                    message.action = reader.string();
                    break;
                case 4:
                    message.disable = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgToggleAction);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.code !== undefined && object.code !== null) {
            message.code = String(object.code);
        }
        else {
            message.code = "";
        }
        if (object.action !== undefined && object.action !== null) {
            message.action = String(object.action);
        }
        else {
            message.action = "";
        }
        if (object.disable !== undefined && object.disable !== null) {
            message.disable = Boolean(object.disable);
        }
        else {
            message.disable = false;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.code !== undefined && (obj.code = message.code);
        message.action !== undefined && (obj.action = message.action);
        message.disable !== undefined && (obj.disable = message.disable);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgToggleAction);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.code !== undefined && object.code !== null) {
            message.code = object.code;
        }
        else {
            message.code = "";
        }
        if (object.action !== undefined && object.action !== null) {
            message.action = object.action;
        }
        else {
            message.action = "";
        }
        if (object.disable !== undefined && object.disable !== null) {
            message.disable = object.disable;
        }
        else {
            message.disable = false;
        }
        return message;
    },
};
var baseMsgToggleActionResponse = { code: "", name: "" };
exports.MsgToggleActionResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.code !== "") {
            writer.uint32(10).string(message.code);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        if (message.onchainDataAction !== undefined) {
            on_chain_data_1.OnChainData.encode(message.onchainDataAction, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgToggleActionResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.code = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.onchainDataAction = on_chain_data_1.OnChainData.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgToggleActionResponse);
        if (object.code !== undefined && object.code !== null) {
            message.code = String(object.code);
        }
        else {
            message.code = "";
        }
        if (object.name !== undefined && object.name !== null) {
            message.name = String(object.name);
        }
        else {
            message.name = "";
        }
        if (object.onchainDataAction !== undefined &&
            object.onchainDataAction !== null) {
            message.onchainDataAction = on_chain_data_1.OnChainData.fromJSON(object.onchainDataAction);
        }
        else {
            message.onchainDataAction = undefined;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.code !== undefined && (obj.code = message.code);
        message.name !== undefined && (obj.name = message.name);
        message.onchainDataAction !== undefined &&
            (obj.onchainDataAction = message.onchainDataAction
                ? on_chain_data_1.OnChainData.toJSON(message.onchainDataAction)
                : undefined);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgToggleActionResponse);
        if (object.code !== undefined && object.code !== null) {
            message.code = object.code;
        }
        else {
            message.code = "";
        }
        if (object.name !== undefined && object.name !== null) {
            message.name = object.name;
        }
        else {
            message.name = "";
        }
        if (object.onchainDataAction !== undefined &&
            object.onchainDataAction !== null) {
            message.onchainDataAction = on_chain_data_1.OnChainData.fromPartial(object.onchainDataAction);
        }
        else {
            message.onchainDataAction = undefined;
        }
        return message;
    },
};
var baseMsgChangeSchemaOwner = {
    creator: "",
    nftSchemaCode: "",
    newOwner: "",
};
exports.MsgChangeSchemaOwner = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.nftSchemaCode !== "") {
            writer.uint32(18).string(message.nftSchemaCode);
        }
        if (message.newOwner !== "") {
            writer.uint32(26).string(message.newOwner);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgChangeSchemaOwner);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.nftSchemaCode = reader.string();
                    break;
                case 3:
                    message.newOwner = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgChangeSchemaOwner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.newOwner !== undefined && object.newOwner !== null) {
            message.newOwner = String(object.newOwner);
        }
        else {
            message.newOwner = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.newOwner !== undefined && (obj.newOwner = message.newOwner);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgChangeSchemaOwner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.newOwner !== undefined && object.newOwner !== null) {
            message.newOwner = object.newOwner;
        }
        else {
            message.newOwner = "";
        }
        return message;
    },
};
var baseMsgChangeSchemaOwnerResponse = {
    nftSchemaCode: "",
    newOwner: "",
};
exports.MsgChangeSchemaOwnerResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.nftSchemaCode !== "") {
            writer.uint32(10).string(message.nftSchemaCode);
        }
        if (message.newOwner !== "") {
            writer.uint32(18).string(message.newOwner);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgChangeSchemaOwnerResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nftSchemaCode = reader.string();
                    break;
                case 2:
                    message.newOwner = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgChangeSchemaOwnerResponse);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.newOwner !== undefined && object.newOwner !== null) {
            message.newOwner = String(object.newOwner);
        }
        else {
            message.newOwner = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.newOwner !== undefined && (obj.newOwner = message.newOwner);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgChangeSchemaOwnerResponse);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.newOwner !== undefined && object.newOwner !== null) {
            message.newOwner = object.newOwner;
        }
        else {
            message.newOwner = "";
        }
        return message;
    },
};
var baseMsgAddSystemActioner = {
    creator: "",
    nftSchemaCode: "",
    actioner: "",
};
exports.MsgAddSystemActioner = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.nftSchemaCode !== "") {
            writer.uint32(18).string(message.nftSchemaCode);
        }
        if (message.actioner !== "") {
            writer.uint32(26).string(message.actioner);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgAddSystemActioner);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.nftSchemaCode = reader.string();
                    break;
                case 3:
                    message.actioner = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgAddSystemActioner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.actioner !== undefined && object.actioner !== null) {
            message.actioner = String(object.actioner);
        }
        else {
            message.actioner = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.actioner !== undefined && (obj.actioner = message.actioner);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgAddSystemActioner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.actioner !== undefined && object.actioner !== null) {
            message.actioner = object.actioner;
        }
        else {
            message.actioner = "";
        }
        return message;
    },
};
var baseMsgAddSystemActionerResponse = {
    nftSchemaCode: "",
    actioner: "",
};
exports.MsgAddSystemActionerResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.nftSchemaCode !== "") {
            writer.uint32(10).string(message.nftSchemaCode);
        }
        if (message.actioner !== "") {
            writer.uint32(18).string(message.actioner);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgAddSystemActionerResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nftSchemaCode = reader.string();
                    break;
                case 2:
                    message.actioner = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgAddSystemActionerResponse);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.actioner !== undefined && object.actioner !== null) {
            message.actioner = String(object.actioner);
        }
        else {
            message.actioner = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.actioner !== undefined && (obj.actioner = message.actioner);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgAddSystemActionerResponse);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.actioner !== undefined && object.actioner !== null) {
            message.actioner = object.actioner;
        }
        else {
            message.actioner = "";
        }
        return message;
    },
};
var baseMsgRemoveSystemActioner = {
    creator: "",
    nftSchemaCode: "",
    actioner: "",
};
exports.MsgRemoveSystemActioner = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.nftSchemaCode !== "") {
            writer.uint32(18).string(message.nftSchemaCode);
        }
        if (message.actioner !== "") {
            writer.uint32(26).string(message.actioner);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgRemoveSystemActioner);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.nftSchemaCode = reader.string();
                    break;
                case 3:
                    message.actioner = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgRemoveSystemActioner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.actioner !== undefined && object.actioner !== null) {
            message.actioner = String(object.actioner);
        }
        else {
            message.actioner = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.actioner !== undefined && (obj.actioner = message.actioner);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgRemoveSystemActioner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.actioner !== undefined && object.actioner !== null) {
            message.actioner = object.actioner;
        }
        else {
            message.actioner = "";
        }
        return message;
    },
};
var baseMsgRemoveSystemActionerResponse = {
    nftSchemaCode: "",
    actioner: "",
};
exports.MsgRemoveSystemActionerResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.nftSchemaCode !== "") {
            writer.uint32(10).string(message.nftSchemaCode);
        }
        if (message.actioner !== "") {
            writer.uint32(18).string(message.actioner);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgRemoveSystemActionerResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nftSchemaCode = reader.string();
                    break;
                case 2:
                    message.actioner = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgRemoveSystemActionerResponse);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.actioner !== undefined && object.actioner !== null) {
            message.actioner = String(object.actioner);
        }
        else {
            message.actioner = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.actioner !== undefined && (obj.actioner = message.actioner);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgRemoveSystemActionerResponse);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.actioner !== undefined && object.actioner !== null) {
            message.actioner = object.actioner;
        }
        else {
            message.actioner = "";
        }
        return message;
    },
};
var baseMsgResyncAttributesResponse = { nftSchemaCode: "" };
exports.MsgResyncAttributesResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.nftSchemaCode !== "") {
            writer.uint32(10).string(message.nftSchemaCode);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgResyncAttributesResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nftSchemaCode = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgResyncAttributesResponse);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgResyncAttributesResponse);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        return message;
    },
};
var baseMsgShowAttributes = {
    creator: "",
    nftSchemaCode: "",
    show: false,
    attributeNames: "",
};
exports.MsgShowAttributes = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.nftSchemaCode !== "") {
            writer.uint32(18).string(message.nftSchemaCode);
        }
        if (message.show === true) {
            writer.uint32(24).bool(message.show);
        }
        for (var _i = 0, _a = message.attributeNames; _i < _a.length; _i++) {
            var v = _a[_i];
            writer.uint32(34).string(v);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgShowAttributes);
        message.attributeNames = [];
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.nftSchemaCode = reader.string();
                    break;
                case 3:
                    message.show = reader.bool();
                    break;
                case 4:
                    message.attributeNames.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgShowAttributes);
        message.attributeNames = [];
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.show !== undefined && object.show !== null) {
            message.show = Boolean(object.show);
        }
        else {
            message.show = false;
        }
        if (object.attributeNames !== undefined && object.attributeNames !== null) {
            for (var _i = 0, _a = object.attributeNames; _i < _a.length; _i++) {
                var e = _a[_i];
                message.attributeNames.push(String(e));
            }
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.show !== undefined && (obj.show = message.show);
        if (message.attributeNames) {
            obj.attributeNames = message.attributeNames.map(function (e) { return e; });
        }
        else {
            obj.attributeNames = [];
        }
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgShowAttributes);
        message.attributeNames = [];
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.show !== undefined && object.show !== null) {
            message.show = object.show;
        }
        else {
            message.show = false;
        }
        if (object.attributeNames !== undefined && object.attributeNames !== null) {
            for (var _i = 0, _a = object.attributeNames; _i < _a.length; _i++) {
                var e = _a[_i];
                message.attributeNames.push(e);
            }
        }
        return message;
    },
};
var baseMsgShowAttributesResponse = { nftSchema: "" };
exports.MsgShowAttributesResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.nftSchema !== "") {
            writer.uint32(10).string(message.nftSchema);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgShowAttributesResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nftSchema = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgShowAttributesResponse);
        if (object.nftSchema !== undefined && object.nftSchema !== null) {
            message.nftSchema = String(object.nftSchema);
        }
        else {
            message.nftSchema = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.nftSchema !== undefined && (obj.nftSchema = message.nftSchema);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgShowAttributesResponse);
        if (object.nftSchema !== undefined && object.nftSchema !== null) {
            message.nftSchema = object.nftSchema;
        }
        else {
            message.nftSchema = "";
        }
        return message;
    },
};
var baseMsgResyncAttributes = {
    creator: "",
    nftSchemaCode: "",
    tokenId: "",
};
exports.MsgResyncAttributes = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.nftSchemaCode !== "") {
            writer.uint32(18).string(message.nftSchemaCode);
        }
        if (message.tokenId !== "") {
            writer.uint32(26).string(message.tokenId);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgResyncAttributes);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.nftSchemaCode = reader.string();
                    break;
                case 3:
                    message.tokenId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgResyncAttributes);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.tokenId !== undefined && object.tokenId !== null) {
            message.tokenId = String(object.tokenId);
        }
        else {
            message.tokenId = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.tokenId !== undefined && (obj.tokenId = message.tokenId);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgResyncAttributes);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.tokenId !== undefined && object.tokenId !== null) {
            message.tokenId = object.tokenId;
        }
        else {
            message.tokenId = "";
        }
        return message;
    },
};
var baseMsgSetFeeConfig = {
    creator: "",
    newFeeConfigBase64: "",
    feeSubject: 0,
};
exports.MsgSetFeeConfig = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.newFeeConfigBase64 !== "") {
            writer.uint32(18).string(message.newFeeConfigBase64);
        }
        if (message.feeSubject !== 0) {
            writer.uint32(24).int32(message.feeSubject);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgSetFeeConfig);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.newFeeConfigBase64 = reader.string();
                    break;
                case 3:
                    message.feeSubject = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgSetFeeConfig);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.newFeeConfigBase64 !== undefined &&
            object.newFeeConfigBase64 !== null) {
            message.newFeeConfigBase64 = String(object.newFeeConfigBase64);
        }
        else {
            message.newFeeConfigBase64 = "";
        }
        if (object.feeSubject !== undefined && object.feeSubject !== null) {
            message.feeSubject = feeSubjectFromJSON(object.feeSubject);
        }
        else {
            message.feeSubject = 0;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.newFeeConfigBase64 !== undefined &&
            (obj.newFeeConfigBase64 = message.newFeeConfigBase64);
        message.feeSubject !== undefined &&
            (obj.feeSubject = feeSubjectToJSON(message.feeSubject));
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgSetFeeConfig);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.newFeeConfigBase64 !== undefined &&
            object.newFeeConfigBase64 !== null) {
            message.newFeeConfigBase64 = object.newFeeConfigBase64;
        }
        else {
            message.newFeeConfigBase64 = "";
        }
        if (object.feeSubject !== undefined && object.feeSubject !== null) {
            message.feeSubject = object.feeSubject;
        }
        else {
            message.feeSubject = 0;
        }
        return message;
    },
};
var baseMsgSetFeeConfigResponse = {};
exports.MsgSetFeeConfigResponse = {
    encode: function (_, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgSetFeeConfigResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (_) {
        var message = __assign({}, baseMsgSetFeeConfigResponse);
        return message;
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    fromPartial: function (_) {
        var message = __assign({}, baseMsgSetFeeConfigResponse);
        return message;
    },
};
var baseMsgSetMintauth = {
    creator: "",
    nftSchemaCode: "",
    authorizeTo: 0,
};
exports.MsgSetMintauth = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.nftSchemaCode !== "") {
            writer.uint32(18).string(message.nftSchemaCode);
        }
        if (message.authorizeTo !== 0) {
            writer.uint32(24).int32(message.authorizeTo);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgSetMintauth);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.nftSchemaCode = reader.string();
                    break;
                case 3:
                    message.authorizeTo = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgSetMintauth);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.authorizeTo !== undefined && object.authorizeTo !== null) {
            message.authorizeTo = authorizeToFromJSON(object.authorizeTo);
        }
        else {
            message.authorizeTo = 0;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.authorizeTo !== undefined &&
            (obj.authorizeTo = authorizeToToJSON(message.authorizeTo));
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgSetMintauth);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.authorizeTo !== undefined && object.authorizeTo !== null) {
            message.authorizeTo = object.authorizeTo;
        }
        else {
            message.authorizeTo = 0;
        }
        return message;
    },
};
var baseMsgSetMintauthResponse = { nftSchemaCode: "" };
exports.MsgSetMintauthResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.nftSchemaCode !== "") {
            writer.uint32(10).string(message.nftSchemaCode);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgSetMintauthResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nftSchemaCode = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgSetMintauthResponse);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgSetMintauthResponse);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        return message;
    },
};
var baseMsgChangeOrgOwner = {
    creator: "",
    orgName: "",
    toNewOwner: "",
};
exports.MsgChangeOrgOwner = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.orgName !== "") {
            writer.uint32(18).string(message.orgName);
        }
        if (message.toNewOwner !== "") {
            writer.uint32(26).string(message.toNewOwner);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgChangeOrgOwner);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.orgName = reader.string();
                    break;
                case 3:
                    message.toNewOwner = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgChangeOrgOwner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.orgName !== undefined && object.orgName !== null) {
            message.orgName = String(object.orgName);
        }
        else {
            message.orgName = "";
        }
        if (object.toNewOwner !== undefined && object.toNewOwner !== null) {
            message.toNewOwner = String(object.toNewOwner);
        }
        else {
            message.toNewOwner = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.orgName !== undefined && (obj.orgName = message.orgName);
        message.toNewOwner !== undefined && (obj.toNewOwner = message.toNewOwner);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgChangeOrgOwner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.orgName !== undefined && object.orgName !== null) {
            message.orgName = object.orgName;
        }
        else {
            message.orgName = "";
        }
        if (object.toNewOwner !== undefined && object.toNewOwner !== null) {
            message.toNewOwner = object.toNewOwner;
        }
        else {
            message.toNewOwner = "";
        }
        return message;
    },
};
var baseMsgChangeOrgOwnerResponse = {
    orgName: "",
    oldOwner: "",
    newOwner: "",
};
exports.MsgChangeOrgOwnerResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.orgName !== "") {
            writer.uint32(10).string(message.orgName);
        }
        if (message.oldOwner !== "") {
            writer.uint32(18).string(message.oldOwner);
        }
        if (message.newOwner !== "") {
            writer.uint32(26).string(message.newOwner);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgChangeOrgOwnerResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.orgName = reader.string();
                    break;
                case 2:
                    message.oldOwner = reader.string();
                    break;
                case 3:
                    message.newOwner = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgChangeOrgOwnerResponse);
        if (object.orgName !== undefined && object.orgName !== null) {
            message.orgName = String(object.orgName);
        }
        else {
            message.orgName = "";
        }
        if (object.oldOwner !== undefined && object.oldOwner !== null) {
            message.oldOwner = String(object.oldOwner);
        }
        else {
            message.oldOwner = "";
        }
        if (object.newOwner !== undefined && object.newOwner !== null) {
            message.newOwner = String(object.newOwner);
        }
        else {
            message.newOwner = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.orgName !== undefined && (obj.orgName = message.orgName);
        message.oldOwner !== undefined && (obj.oldOwner = message.oldOwner);
        message.newOwner !== undefined && (obj.newOwner = message.newOwner);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgChangeOrgOwnerResponse);
        if (object.orgName !== undefined && object.orgName !== null) {
            message.orgName = object.orgName;
        }
        else {
            message.orgName = "";
        }
        if (object.oldOwner !== undefined && object.oldOwner !== null) {
            message.oldOwner = object.oldOwner;
        }
        else {
            message.oldOwner = "";
        }
        if (object.newOwner !== undefined && object.newOwner !== null) {
            message.newOwner = object.newOwner;
        }
        else {
            message.newOwner = "";
        }
        return message;
    },
};
var MsgClientImpl = /** @class */ (function () {
    function MsgClientImpl(rpc) {
        this.rpc = rpc;
    }
    MsgClientImpl.prototype.CreateNFTSchema = function (request) {
        var data = exports.MsgCreateNFTSchema.encode(request).finish();
        var promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Msg", "CreateNFTSchema", data);
        return promise.then(function (data) {
            return exports.MsgCreateNFTSchemaResponse.decode(new minimal_1.Reader(data));
        });
    };
    MsgClientImpl.prototype.CreateMetadata = function (request) {
        var data = exports.MsgCreateMetadata.encode(request).finish();
        var promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Msg", "CreateMetadata", data);
        return promise.then(function (data) {
            return exports.MsgCreateMetadataResponse.decode(new minimal_1.Reader(data));
        });
    };
    MsgClientImpl.prototype.PerformActionByAdmin = function (request) {
        var data = exports.MsgPerformActionByAdmin.encode(request).finish();
        var promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Msg", "PerformActionByAdmin", data);
        return promise.then(function (data) {
            return exports.MsgPerformActionByAdminResponse.decode(new minimal_1.Reader(data));
        });
    };
    MsgClientImpl.prototype.AddAttribute = function (request) {
        var data = exports.MsgAddAttribute.encode(request).finish();
        var promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Msg", "AddAttribute", data);
        return promise.then(function (data) {
            return exports.MsgAddAttributeResponse.decode(new minimal_1.Reader(data));
        });
    };
    MsgClientImpl.prototype.AddAction = function (request) {
        var data = exports.MsgAddAction.encode(request).finish();
        var promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Msg", "AddAction", data);
        return promise.then(function (data) {
            return exports.MsgAddActionResponse.decode(new minimal_1.Reader(data));
        });
    };
    MsgClientImpl.prototype.SetNFTAttribute = function (request) {
        var data = exports.MsgSetNFTAttribute.encode(request).finish();
        var promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Msg", "SetNFTAttribute", data);
        return promise.then(function (data) {
            return exports.MsgSetNFTAttributeResponse.decode(new minimal_1.Reader(data));
        });
    };
    MsgClientImpl.prototype.SetBaseUri = function (request) {
        var data = exports.MsgSetBaseUri.encode(request).finish();
        var promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Msg", "SetBaseUri", data);
        return promise.then(function (data) {
            return exports.MsgSetBaseUriResponse.decode(new minimal_1.Reader(data));
        });
    };
    MsgClientImpl.prototype.ToggleAction = function (request) {
        var data = exports.MsgToggleAction.encode(request).finish();
        var promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Msg", "ToggleAction", data);
        return promise.then(function (data) {
            return exports.MsgToggleActionResponse.decode(new minimal_1.Reader(data));
        });
    };
    MsgClientImpl.prototype.ChangeSchemaOwner = function (request) {
        var data = exports.MsgChangeSchemaOwner.encode(request).finish();
        var promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Msg", "ChangeSchemaOwner", data);
        return promise.then(function (data) {
            return exports.MsgChangeSchemaOwnerResponse.decode(new minimal_1.Reader(data));
        });
    };
    MsgClientImpl.prototype.AddSystemActioner = function (request) {
        var data = exports.MsgAddSystemActioner.encode(request).finish();
        var promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Msg", "AddSystemActioner", data);
        return promise.then(function (data) {
            return exports.MsgAddSystemActionerResponse.decode(new minimal_1.Reader(data));
        });
    };
    MsgClientImpl.prototype.RemoveSystemActioner = function (request) {
        var data = exports.MsgRemoveSystemActioner.encode(request).finish();
        var promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Msg", "RemoveSystemActioner", data);
        return promise.then(function (data) {
            return exports.MsgRemoveSystemActionerResponse.decode(new minimal_1.Reader(data));
        });
    };
    MsgClientImpl.prototype.ResyncAttributes = function (request) {
        var data = exports.MsgResyncAttributes.encode(request).finish();
        var promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Msg", "ResyncAttributes", data);
        return promise.then(function (data) {
            return exports.MsgResyncAttributesResponse.decode(new minimal_1.Reader(data));
        });
    };
    MsgClientImpl.prototype.ShowAttributes = function (request) {
        var data = exports.MsgShowAttributes.encode(request).finish();
        var promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Msg", "ShowAttributes", data);
        return promise.then(function (data) {
            return exports.MsgShowAttributesResponse.decode(new minimal_1.Reader(data));
        });
    };
    MsgClientImpl.prototype.SetFeeConfig = function (request) {
        var data = exports.MsgSetFeeConfig.encode(request).finish();
        var promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Msg", "SetFeeConfig", data);
        return promise.then(function (data) {
            return exports.MsgSetFeeConfigResponse.decode(new minimal_1.Reader(data));
        });
    };
    MsgClientImpl.prototype.SetMintauth = function (request) {
        var data = exports.MsgSetMintauth.encode(request).finish();
        var promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Msg", "SetMintauth", data);
        return promise.then(function (data) {
            return exports.MsgSetMintauthResponse.decode(new minimal_1.Reader(data));
        });
    };
    MsgClientImpl.prototype.ChangeOrgOwner = function (request) {
        var data = exports.MsgChangeOrgOwner.encode(request).finish();
        var promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Msg", "ChangeOrgOwner", data);
        return promise.then(function (data) {
            return exports.MsgChangeOrgOwnerResponse.decode(new minimal_1.Reader(data));
        });
    };
    return MsgClientImpl;
}());
exports.MsgClientImpl = MsgClientImpl;
